import React, { useState, useEffect} from 'react';
import { Input, Select, message, Modal, Tooltip } from 'antd';
import { ArrowUpOutlined  } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";

import "./index.scss";
import Api from '../../api'
import Iconfont from "../Iconfont/Iconfont";
import Start from "../../assets/img/V7/start.png";
import UploadFileModalV7 from "../UploadFileModalV7";
import { setAIModalState, setQAKowledgeList } from "../../features/AIIntelligentV7/AIReducer";
import { getSizeText } from "../../utils/tool";
import UploadFileIcon from "./uploadFileIcon.js"
import storage from '../../utils/storage.js';
import UploadSingle from "./uploadSingle";

const { TextArea } = Input;
// 基础知识类型
const knowledgeTypeList = ['1','2','3','4','5','6','9']
const QASearchInput = ({
    pageType,
    scopeQA,
    defaultSearchValue,
    sendQuestion,
    isAnswering,
    stopAnswer,
    questionParam,
    clientId
}) => {
    const dispatch = useDispatch();
    const uploadModalOpen = useSelector(state => state.AIReducerV7.uploadModalOpen);
    const QAKowledgeList = useSelector(state => state.AIReducerV7.QAKowledgeList);

    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState([]);
    const [selectValue, setSelectValue] = useState('9999');
    const [searchTypeDisable, setSearchTypeDisable] = useState(false);

    const [upFileList, setUpFileList] = useState([]);
    const [textAreaPlaceholder, setTextAreaPlaceholder] = useState("描述你的检索需求或问题");

    useEffect(()=>{ 
        if(defaultSearchValue){
            setSearchValue(defaultSearchValue);
        }
    },[defaultSearchValue])

    useEffect(()=>{ 
        console.log(selectValue,'selectValue');
    },[selectValue])

     useEffect(()=>{ 
        getSelectValue();
    },[pageType, scopeQA, questionParam])

    useEffect(()=>{
        if(!clientId){
            setTextAreaPlaceholder("描述你的检索需求或问题");
            
        }
    },[clientId])

    useEffect(()=>{
        getInitDate();
    },[])

    useEffect(()=>{
        if((QAKowledgeList && QAKowledgeList.length>0) || (upFileList && upFileList.length>0)){
            // 上传文件，或者选择了文件，范围切换为自定义范围
            setSelectValue('customize');
            setSearchTypeDisable(true);
        }else{
            // setSelectValue(
            //     (scopeQA === '4' || scopeQA === '7') ? "customize" : 
            //     pageType === "knowledgeQA" ? 'home' : scopeQA);
            // setSearchTypeDisable(false);
            setSearchTypeDisable(false);
            getSelectValue();
        }
    },[QAKowledgeList,upFileList])

    const getSelectValue = () => { 
        if((upFileList && upFileList.length>0) || (QAKowledgeList && QAKowledgeList.length>0)){
            // 已上传文件 / 添加文件
            // 类型不可切换 - 默认为自定义范围
            setSelectValue('customize');
            setSearchTypeDisable(true);
        }else if(scopeQA === '4' || scopeQA === '7'){
            // 政策和研报页面不能够直接提问，必须选择文件提问
            // 禁止选择类型
            setSelectValue('customize');
            setSearchTypeDisable(true);
        }else if(pageType === "home"){
            setSelectValue('home');
            setSearchTypeDisable(false);
        }else if(pageType === "knowledgeCentre"){
            setSearchTypeDisable(true);
            setSelectValue((scopeQA === '4' || scopeQA === '7') ? "customize" : scopeQA);
        }else if(pageType === "knowledgeQA"){
            // 知识搜索界面
            setTextAreaPlaceholder("继续追问...");
            console.log(questionParam,'questionParam');
            if(questionParam && questionParam.ext){
                setQuestionParam();
            }else{
                setSearchTypeDisable(false);
                setSelectValue('home');
            }
        }else if(pageType === 'knowledgeSearchES'){
            if(
                QAKowledgeList &&
                QAKowledgeList.length>0 && 
                (QAKowledgeList[0].knowledgeTypeId ==='4' || QAKowledgeList[0].knowledgeTypeId ==='7')
            ){
                setSelectValue("customize");
                setSearchTypeDisable(true);
            }
        }else{
            setSearchTypeDisable(false);
            setSelectValue((scopeQA === '4' || scopeQA === '7') ? "customize" : scopeQA);
        }
    }

    const setQuestionParam = () => {
        if(questionParam.ext){
            const {KnowledgeEsParam, knowledgeIds, fileIds, imgIds, policyIds, selectKnowledgeParam} = questionParam.ext;
            if(KnowledgeEsParam && JSON.stringify(KnowledgeEsParam) != '{}'){
                setSelectValue('knowledgeSearchES');
            }else if(knowledgeIds.length > 0 || policyIds.length > 0 || fileIds.length > 0 || imgIds.length > 0){
                setSelectValue("customize");
                setSearchTypeDisable(true);
            }else if(selectKnowledgeParam && selectKnowledgeParam.knowledgeTypeId){
                setSelectValue(selectKnowledgeParam.knowledgeTypeId);
            }
        }
        
    }


    const getInitDate = async() => {
        const res = await Api.Knowledge.getAllKnowledger({});
        if(res && res.code === 0){
            let newData = [];
            let _searchType = [
                ...res.data,
                {'knowledgeTypeName':'个人资料',id:'personalData'},
                {'knowledgeTypeName':'专题收藏',id:'collection'},
                {'knowledgeTypeName':'自定义范围',id:'customize'},
                {'knowledgeTypeName':'搜索结果',id:'knowledgeSearchES'},
            ]

            if(pageType === 'home'){
                // 首页AI问答范围没有政策、研报、搜索结果
                // 自定义范围显示但不可选
                _searchType.map(item=>{ 
                    if((item.id!=='4' && item.id!=='7' && item.id!=='knowledgeSearchES' && item.id!=='customize')){
                        newData.push(item)
                    }
                })
                newData.unshift({'knowledgeTypeName':'整个知识库',id:'home'});
                newData.push({'knowledgeTypeName':'自定义范围',id:'customize', disabled:true});
                
            }else if(pageType === 'knowledgeQA'){
                // 问答结果页的范围 没有政策、研报
                _searchType.map(item=>{
                    if((item.id!=='4' && item.id!=='7')){
                        newData.push(item)
                    }
                })
                newData.unshift({'knowledgeTypeName':'整个知识库',id:'home'});
            }else{
                newData = _searchType
            }
            
            setSearchType(newData);
        }
    }

    const openUploadModal = () => {
        dispatch(setAIModalState({
            uploadModalOpen: true,
        }))
    }

    const uploadFileOk = (state) => {
        let sucFileList = [...upFileList];
        let tipsText = "上传的文件中：";
        let hasScannedCopy = false;

        state.fileList.map((item,index)=>{
            if(item.otherData && (item.otherData.isScan === 1)){
                // 扫描件
                tipsText += index === 0 ? item.name : ", " + item.name;
                hasScannedCopy = true;
            }
            if(item.status === 'success' && item.otherData && (item.otherData.isScan != 1)){
                item.otherData.fileId = item.otherData.fId || item.otherData.fileId
                sucFileList.push(item)
            }
        })

        if(sucFileList.length>0){
            setTextAreaPlaceholder("问个问题，或输入关键词进行搜索")
        }

        if(hasScannedCopy){
            // 有扫描件
            Modal.info({
                title: '提示',
                content: (
                <div>
                    <p>{tipsText}为扫描件</p>
                    <p>目前AI问答不支持扫描件问答，已为您自动剔除</p>
                </div>
                ),
                onOk() {},
            });
        }

        setUpFileList(sucFileList)
        console.log(state,sucFileList,"state");
    }

    const deleteFile = (item) => {
        let newFileList = [];
        upFileList.map(fileItem=>{
            if(fileItem.otherData.fileId !== item.otherData.fileId){
                newFileList.push(fileItem)
            }
        })
        setUpFileList([...newFileList])
    }

    const onSend = () => { 
        if(!searchValue){
            return false;
        }

        if(upFileList && upFileList.length > 3){
            message.error('最多上传3个文件问答');
            return false;
        }

        
        if(selectValue === 'customize' && !upFileList.length && !QAKowledgeList.length && !clientId){
            message.error('自定义范围需选择文件或者上传文件后提问')
            return false;
        }

        if(
            (selectValue === '4' || selectValue === '7') && !upFileList.length && !QAKowledgeList.length){
            // 政策和研报页面不能够直接提问，必须选择文件提问
            message.error('请选择文件或者上传文件后提问')
            return false;
        }

        // 0-ES搜索的查询条件 
        // 1-知识中心的查询条件 
        // 2-个人资料查询条件 
        // 3-专题收藏查询条件
        // 上传文件，添加文件，政策，研报的情况为空
        let searchScope = null;

        // 是否有添加文件/上传闻恩建
        let hasFile = (upFileList.length > 0 || QAKowledgeList.length > 0)

        // ES搜索界面
        let KnowledgeEsParam = {}
        if(selectValue === 'knowledgeSearchES' && !hasFile){
            KnowledgeEsParam = storage.getItem('knowledgeEsParam');
            searchScope = 0;
        }

        // 知识中心-普通知识类型
        
        let selectKnowledgeParam = {};
        if(knowledgeTypeList.includes(selectValue) && !hasFile){
            selectKnowledgeParam = {
                "knowledgeTypeId": selectValue
            }
            searchScope = 1;
        }

        // 个人资料
        if(selectValue === 'personalData' && !hasFile){
            searchScope = 2;
        }

        // 专题收藏
        if(selectValue === 'collection' && !hasFile){
            searchScope = 3;
        }
        

        let _upFileList = [];
        upFileList.map(item=>{
            _upFileList.push({
                ...item,
                'name': item.name,
                'size': item.size,
                'type': item.type,
            })
        })

        let param = {
            "fileList": _upFileList,
            "query": searchValue,
            "knowledgeList": QAKowledgeList,
            "selectKnowledgeParam": selectKnowledgeParam,
            "KnowledgeEsParam": KnowledgeEsParam,
            "searchScope": searchScope
        }
        

        if(pageType === "knowledgeQA"){
            sendQuestion(param);
        }else{
            storage.setItem('aiQAParams', param);
            window.open('/page/knowledgeQA');
        }

        dispatch(setAIModalState({
            "QAKowledgeList":[]
        }))

        setSearchTypeDisable(false);
        setSearchValue("");
        setUpFileList([]);
        getSelectValue();
        
    }

    const uploadFileCallBack = (sucFileList) => {
        console.log(sucFileList)
        setUpFileList(sucFileList)
    }
    
    return (
        <div className="QASearchInput">
            <div className="searchBar">

                {upFileList&&upFileList.length>0&&
                <div className="fileBox">
                    {upFileList.map((item,index)=>{ 
                        let fileName = item.name;
                        const lastDotIndex = fileName.lastIndexOf(".");
                        let fileTypeLower = fileName.slice(lastDotIndex + 1).toLowerCase();
                        let fileType = fileName.slice(lastDotIndex + 1).toUpperCase();
                        return(
                            <div className="fileItem" key={item.otherData.fileId}>
                                <div className="fileIcon">
                                    <UploadFileIcon fileType={fileTypeLower}/>
                                </div>
                                <div className="fileContent">
                                    <div className="fileName">{fileName}</div>
                                    <div className="fileName">{fileType} {getSizeText(item.size,'b')}</div>
                                </div>
                                <Iconfont type="icon-cuowu" onClick={()=>deleteFile(item)}/>
                            </div>
                        )
                    })}
                </div>}

                {(upFileList&&upFileList.length >= 3) && <div className="footTips">最多可上传3个文件问答</div>}

                {/* {upFileList&&upFileList.length>0&&<div className="questionTip">你可能想知道：<span>DeepSeek-R1如何本地化部署？</span></div>} */}

                <TextArea placeholder={textAreaPlaceholder} autoSize={{
                    minRows: 2,
                    maxRows: 6,
                }} value={searchValue} onChange={(e) => setSearchValue(e.target.value)} 
                onPressEnter={()=>{
                    if(isAnswering && stopAnswer){
                        stopAnswer()
                    }else if(!isAnswering && searchValue){
                        onSend()
                    }
                }}/>
            </div>

            <div className="searchOpration">
                <div className="leftOpration">
                    <div className="statusIcon">
                        <div className="statusIconCenter"></div>
                    </div>
                    <Select
                        value={selectValue}
                        bordered={false}
                        options={searchType}
                        disabled={searchTypeDisable}
                        fieldNames={{ label: 'knowledgeTypeName', value: 'id'}}
                        onChange={(value) => setSelectValue(value)}
                    />

                    <Tooltip  placement={"bottom"} title={"上传本地文档问答，最多3个文件，每个50M，支持Word、PDF、PPT、Excel，不支持扫描件"}>
                        <div className={`uploadFile ${upFileList&&upFileList.length>=3 ? 'disabledBtn' : ''}`} onClick={()=>{
                            if(upFileList&&upFileList.length<3){
                                openUploadModal();
                            }
                        }}>
                            <Iconfont type="icon-guanlian"/>
                        </div>
                    </Tooltip>

                    

                    {/* <UploadSingle
                        contentHTml={<Iconfont type="icon-guanlian"/>}
                        callBack={uploadFileCallBack}
                        isDisabled={(upFileList&&upFileList.length>0) ? true : false}
                    /> */}
                        
                </div>
                <div className="rightOpration">
                    {/* <div className="modelType"><img src={Start} alt=""/>qwq 32b</div> */}
                    <div className={`sendBtn ${searchValue || isAnswering ? 'active' : ''}`} onClick={()=>{
                        if(isAnswering && stopAnswer){
                            stopAnswer();
                        }else if(!isAnswering && searchValue){
                            onSend();
                        }
                    }}>
                        {/* <Iconfont type="icon-zhongzhi" /> */}
                        {isAnswering ? <div className="stopIcon">■</div> : <ArrowUpOutlined />}
                    </div>
                </div>
            </div>

            {uploadModalOpen && <UploadFileModalV7 uploadType={'aiAnalysis'} onOk={uploadFileOk}/>}
        </div>
    );
}
export default QASearchInput;
